export class MassAnswerChecklistItem {
  public checkListItemId: number;
  public justificationId?: number;
  public comment: string;
  public monitorInteractionItemStatus: { id: string };
}
